import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { MbscCalendarEvent, MbscDateType, MbscEventcalendarView, MbscModule } from '@mobiscroll/angular';

import { FormsModule } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { freeSet } from '@coreui/icons';
import { IconDirective } from '@coreui/icons-angular';
import { filter } from 'rxjs';
import { MenuSidebarComponent } from './sidebar/menu-sidebar.component';
import { ThemeService } from '../../../../services/shared/theme/theme.service';
import { AuthService } from '../../../../services/auth/service/auth.service';
import { GetUserService } from '../../../../services/fetchUser/GET/get-user.service';
import { BadgeComponent, ButtonDirective, DropdownComponent, DropdownHeaderDirective, DropdownMenuDirective, DropdownToggleDirective, HeaderNavComponent } from '@coreui/angular-pro';


@Component({
  selector: 'app-header',
  imports: [
    MbscModule,
    CommonModule,
    FormsModule,
    HeaderNavComponent,
    DropdownComponent,
    DropdownHeaderDirective,
    DropdownMenuDirective,
    DropdownToggleDirective
],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  constructor(
    public themeService: ThemeService,
    private authService: AuthService,
    private router: Router,
    private GetUserService: GetUserService
  ) {}

  icons = freeSet;

  @Output() eventClicked = new EventEmitter<any>();
  @Output() toggleOverlay = new EventEmitter<boolean>();

  @Input() selectedDateInput!: MbscDateType;

  popupAnchor: HTMLElement | undefined;
  listEvents: MbscCalendarEvent[] = [];
  originalEvents: MbscCalendarEvent[] = [];
  displayResults = false;
  timer?: ReturnType<typeof setTimeout>;
  selectedDate: MbscDateType = new Date();
  listView: MbscEventcalendarView = { agenda: { type: 'year', size: 5 } };

  // Dropdown states
  isUserDropdownOpen: boolean = false;

  isSidebarVisible = false;
  smallTabView: boolean = false;
  showSidebarButton: boolean = false;
  dragging: boolean = false;
  userName: string = 'Benutzername';
  userEmail: string = '';
  userRole: any;
  smallScreen = false;
  currentUrl: string = '';
  eventListHeight = 800;
  eventSearchInput: any = '';
  advancedSearchPlaceholder: string = '';
  userIconUrl: any;
  private closeTimeout: any;

  /**
 * Initialisiert Router-Events und Userdaten beim Start.
 * Lädt Name, Email, Icon und prüft Bildschirmgröße.
 */
  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentUrl = event.urlAfterRedirects
      });
  
    this.getUserName();
    this.getUserEmail();
    this.checkWindowSize();
    this.loadUserIcon();
  }

  /**
 * Setzt den Suchinput abhängig von der aktuellen Route.
 */
  setInputValue(value: any) {
    if (this.currentUrl.includes('search-event-view')) {
      this.eventSearchInput = `(title=${value})`;
    } else if (this.currentUrl.includes('search-advanced-event-view')) {
      this.eventSearchInput = `${value}`;
    } else {
      this.eventSearchInput = '';
    }
  }

  /**
 * Lädt das Benutzerbild vom Backend oder nutzt Fallback.
 */
  loadUserIcon() {
    this.userIconUrl = './../../../../assets/icons/user.png';

    this.GetUserService.loadUserIcon().subscribe(
      (blob: Blob | null) => {
        if (blob && blob.size > 0) {
          this.userIconUrl = URL.createObjectURL(blob);
          // console.log('Benutzerbild erfolgreich geladen:', this.userIconUrl);
        } else {
          console.warn('Kein gültiges Benutzerbild vorhanden.');
          this.userIconUrl = './../../../../assets/img/app-icons/user.png';
        }
      },
      (error: any) => {
        console.error('Fehler beim Laden des Benutzerbildes:', error);
        this.userIconUrl = './../../../../assets/img/app-icons/user.png';
      }
    );
  }

  /**
 * Reagiert auf Fenstergrößenänderung.
 */
  @HostListener('window:resize', [])
  onResize() {
    this.checkWindowSize();
  }

  /**
 * Prüft Bildschirmgröße für responsive UI-Anpassung.
 */
  private checkWindowSize() {
    this.showSidebarButton = window.innerWidth <= 800;
    this.smallTabView = window.innerWidth <= 2540;
  }

  /**
 * Holt den vollständigen Benutzernamen aus dem LocalStorage.
 */
  getUserName() {
    const firstname = localStorage.getItem('firstName');
    const lastname = localStorage.getItem('lastName');
    this.userName = firstname + ' ' + lastname;
  }

  /**
 * Holt die Benutzer-E-Mail aus dem gespeicherten Auth-Objekt.
 */
    getUserEmail() {
  const userJson = localStorage.getItem('authUser');

  if (userJson) {
    const authUser = JSON.parse(userJson);
    this.userEmail = authUser.user?.email;
  }
}

/**
 * Liest Benutzerberechtigungen für Calendar-Module aus.
 */
    getUserPermission() {
    const authUserString = localStorage.getItem('authUser');
    if (!authUserString) return null;

    try {
      const authUser = JSON.parse(authUserString);
      const permissions = authUser.user?.permissions
        ? JSON.parse(authUser.user.permissions)
        : [];
      const calendarPermission = permissions.find(
        (p: any) => p.app_name === 'CALENDAR-ADMIN'
      );
      return calendarPermission.permission_level || null;
    } catch (error) {
      console.error('Fehler beim Parsen:', error);
      return null;
    }
  }

  /**
 * Öffnet externe Webseiten in neuem Tab.
 */
  openWebsite(path: string) {
    if (path === 'intranet') {
      window.open('https://intranet.tridimo.de/dashboard', '_blank');
    } else if (path == 'bestaetigung') {
      window.open('https://bestaetigung.tridimo.de', '_blank');
    } else if (path == 'aufgaben') {
      window.open('https://aufgaben.tridimo.de/todo', '_blank');
    }
  }

  /**
 * Navigiert innerhalb der Angular-App.
 */
  navigateTo(path: string) {
    this.router.navigate([path]);
  }

  /**
 * Loggt den Benutzer aus über AuthService.
 */
  logout() {
    this.authService.logout();
  }

  /**
 * Erzwingt einen kompletten Reload der Seite.
 */
  reloadPage() {
    window.location.reload();
  }
}